var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoGalleryImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5ac0bdef-6228-446b-9fac-8f783835461c",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f7b35b96-4f67-46c6-8347-3fb58b9c5533",
    x1: 25.87,
    y1: 347.04,
    x2: 83.87,
    y2: 289.04,
    gradientTransform: "translate(0 345) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    className: "stop1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-bae5092e-77d0-4630-9b1a-72486d3562ee",
    x1: 21.21,
    y1: 337.7,
    x2: 90.87,
    y2: 268.04,
    xlinkHref: "#uuid-f7b35b96-4f67-46c6-8347-3fb58b9c5533"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f02e5c6d-5f1e-494e-9a21-6d2125e268fe",
    x1: 28.09,
    y1: 42.09,
    x2: 62.91,
    y2: 76.91,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#uuid-f7b35b96-4f67-46c6-8347-3fb58b9c5533"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m75.5,63.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-f7b35b96-4f67-46c6-8347-3fb58b9c5533)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68.5,70.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-bae5092e-77d0-4630-9b1a-72486d3562ee)",
    opacity: 0.5,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m61.5,41.5H29.5c-1.1,0-2,.9-2,2v32c0,1.1.9,2,2,2h32c1.1,0,2-.9,2-2v-32c0-1.1-.9-2-2-2Zm-21.57,7.78c1.65,0,3,1.35,3,3s-1.35,3-3,3-3-1.35-3-3,1.35-3,3-3Zm21.57,25.22c0,.55-.45,1-1,1h-30c-.55,0-1-.45-1-1v-8.25c0-.27.11-.52.29-.71l4.56-4.56c.78-.78,2.05-.78,2.83,0l2.81,2.81c.39.39,1.02.39,1.41,0l10.22-10.22c.78-.78,2.05-.78,2.83,0l6.75,6.75c.19.19.29.44.29.71v13.47Z",
    fill: "url(#uuid-f02e5c6d-5f1e-494e-9a21-6d2125e268fe)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoGalleryImages);
export default __webpack_public_path__ + "static/media/expo_gallery_images.3251695b779aa4c3eb2cbb421b6cb802.svg";
export { ForwardRef as ReactComponent };